import type { IModelConnection } from "@itwin/core-frontend";
import { QueryRowFormat, QueryBinder } from "@itwin/core-common";
import { PayItem } from "../../../domain/contracts/PayItem";
import { DOTPayItemIndex } from "./dotPayItemQuery";

const DOTPAYITEM_SCHEMA =
  "DgnCustomItemTypes_DOT_DigitalAssetMetadata";

/**
 * Build the ECSQL for the given DOT_PayItem index (1..5).
 */
function buildPayItemQuery(index: DOTPayItemIndex): string {
  if (index < 1 || index > 5) {
    throw new Error(`Invalid DOT_PayItem index: ${index}`);
  }

  return `
    SELECT
      p.PayItem.REFITEM_NM     AS REFITEM_NM,
      p.PayItem.SpecBook       AS SpecBook,
      p.PayItem.Class          AS Class,
      p.PayItem.Type           AS Type,
      p.PayItem.Item           AS Item,
      p.PayItem.Description    AS Description,
      p.PayItem.Unit           AS Unit,
      p.PayItem.UnitPlan       AS UnitPlan,
      p.PayItem.IsPlanQty      AS IsPlanQty
    FROM ${DOTPAYITEM_SCHEMA}.DOT_PayItem${index}ElementAspect p
    WHERE p.Element.Id = ?
  `;
}

export async function queryPayItemForElement(
  iModel: IModelConnection,
  elementId: string,
  index: DOTPayItemIndex,
): Promise<PayItem | undefined> {

  const bindings = QueryBinder.from([elementId]);

  const reader = iModel.createQueryReader(
    buildPayItemQuery(index),
    bindings,
    { rowFormat: QueryRowFormat.UseECSqlPropertyNames }
  );

  for await (const row of reader) {
    // Row has columns with the aliases above (REFITEM_NM, SpecBook, Class, ...)
    const plain = row.toRow() as any;
    return PayItem.fromObject(plain);
  }

  // No pay item row for this element / index
  return undefined;
}

